var n=function(){return"".concat(8*(arguments.length>0&&void 0!==arguments[0]?arguments[0]:1),"px")};export{n as s};
//# sourceMappingURL=layout-f23305e1.js.map
